(() => {
  'use strict';

  if (window.__artmereHorizontalMediaV1) return;
  window.__artmereHorizontalMediaV1 = { version: '1.0.3' };

  const selector = 'img[data-artmere-horizontal-media]';
  const cardSelector = '.product-card, .artmere-collector-homes__card';
  let observer = null;

  const activate = (image) => {
    if (!(image instanceof HTMLImageElement) || !image.hasAttribute('data-artmere-horizontal-media')) return;
    const sizes = image.getAttribute('data-sizes');
    const srcset = image.getAttribute('data-srcset');
    const src = image.getAttribute('data-src');
    image.setAttribute('data-artmere-horizontal-media-state', 'loading');
    if (sizes) image.sizes = sizes;
    if (srcset) image.srcset = srcset;
    if (src) image.src = src;
    image.removeAttribute('data-artmere-horizontal-media');
    image.removeAttribute('data-src');
    image.removeAttribute('data-srcset');
    image.removeAttribute('data-sizes');
    image.addEventListener('load', () => image.setAttribute('data-artmere-horizontal-media-state', 'loaded'), { once: true });
    if (observer) observer.unobserve(image);
  };

  const activateCard = (target) => {
    const card = target instanceof Element ? target.closest(cardSelector) : null;
    if (!card) return;
    card.querySelectorAll(selector).forEach(activate);
  };

  const observePending = () => {
    document.querySelectorAll(selector).forEach((image) => observer ? observer.observe(image) : activate(image));
  };

  const init = () => {
    if ('IntersectionObserver' in window) {
      observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) activate(entry.target);
        });
      }, {
        root: null,
        rootMargin: '600px 220px 600px 220px',
        threshold: 0.01
      });
    }

    observePending();

    // Prime only the visible primary image of the next two horizontal sections.
    // Low priority prevents these below-fold requests from competing with the hero/LCP image.
    const primePrimaryImages = (container, count) => {
      if (!container) return;
      [...container.querySelectorAll(cardSelector)].slice(0, count).forEach((card) => {
        const primaryImage = card.querySelector('img');
        if (!primaryImage) return;
        primaryImage.loading = 'eager';
        primaryImage.fetchPriority = 'low';
        activate(primaryImage);
      });
    };
    primePrimaryImages(document.querySelectorAll('ul.l4cl.slider')[1], 4);
    primePrimaryImages(document.querySelector('artmere-collector-slider'), 5);

    document.addEventListener('pointerover', (event) => activateCard(event.target), { passive: true });
    document.addEventListener('focusin', (event) => activateCard(event.target));
    document.addEventListener('touchstart', (event) => activateCard(event.target), { passive: true });
    window.addEventListener('pageshow', observePending, { passive: true });

  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
